import { useCopy } from "@hooks:useCopy";
import { IconButton, Tooltip } from "@mui/material";
import { MouseEvent } from "react";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { LuCopy } from "react-icons/lu";

interface CopyProps {
  text?: string;
  tooltipText?: string;
}
export const Copy = ({ text, tooltipText = "Copy" }: CopyProps) => {
  const { copy, isCopied } = useCopy();

  const handleCopy = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      copy(text);
    } catch {
      /* empty */
    }
  };

  return (
    <Tooltip title={tooltipText}>
      <IconButton size="small" onClick={handleCopy}>
        {isCopied ? <IoCheckmarkDoneOutline /> : <LuCopy />}
      </IconButton>
    </Tooltip>
  );
};
